(() => {
  if (window.OztechConfigurator) {
    window.OztechConfigurator.initAll();
    return;
  }

  const money = (cents) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  };


  const textPriceToCents = (value) => {
    if (!value) return 0;

    const cleaned = String(value)
      .replace(/,/g, '')
      .match(/[\d]+(?:\.\d+)?/);

    if (!cleaned) return 0;

    return Math.round(
      parseFloat(cleaned[0]) * 100
    );
  };


  const initConfigurator = (root) => {
    if (!root) return;

    if (root.dataset.ozConfiguratorReady === 'true') {
      return;
    }

    root.dataset.ozConfiguratorReady = 'true';


    const baseInputs = Array.from(
      root.querySelectorAll('.ozc-base-input')
    );

    const addonCards = Array.from(
      root.querySelectorAll('[data-addon-card]')
    );


    const summaryBase =
      root.querySelector('[data-summary-base]');

    const summaryBasePrice =
      root.querySelector('[data-summary-base-price]');

    const summaryItems =
      root.querySelector('[data-summary-items]');

    const summaryTotal =
      root.querySelector('[data-summary-total]');

    const cartNotice =
      root.querySelector('[data-cart-notice]');

    const addCartButton =
      root.querySelector('[data-add-cart]');

    const buyNowButton =
      root.querySelector('[data-buy-now]');

    const quoteButton =
      root.querySelector('[data-request-quote]');

    const quoteOnlyButton =
      root.querySelector('[data-quote-only-action]');

    const secondaryActions =
      root.querySelector('.ozc-summary__secondary-actions');

    let cartRequestPending = false;


    const normalizeQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);

      return Number.isFinite(quantity) && quantity > 0
        ? quantity
        : 1;
    };


    const getPriceCents = (element) => {
      const productPrice =
        Number(element.dataset.priceCents || 0);

      if (productPrice > 0) {
        return productPrice;
      }

      return textPriceToCents(
        element.dataset.priceText || ''
      );
    };


    const getSelectedBase = () => {
      return baseInputs.find(
        (input) => input.checked
      );
    };


    const syncBaseCards = () => {
      const selected = getSelectedBase();

      root
        .querySelectorAll('[data-base-card]')
        .forEach((card) => {
          const input =
            card.querySelector('.ozc-base-input');

          card.classList.toggle(
            'is-selected',
            Boolean(input && input.checked)
          );
        });


      root
        .querySelectorAll('[data-route-card]')
        .forEach((card) => {
          card.classList.toggle(
            'is-active',
            Boolean(
              selected &&
              card.dataset.routeCard ===
                selected.dataset.baseKey
            )
          );
        });
    };


    const applyBaseRules = () => {
      const selected = getSelectedBase();

      if (!selected) return;

      const hasSpreader =
        selected.dataset.hasSpreader === 'true';


      addonCards.forEach((card) => {
        const shouldHide =
          card.dataset.hideWhenSpreader === 'true' &&
          hasSpreader;

        card.hidden = shouldHide;


        if (shouldHide) {
          const input =
            card.querySelector('[data-addon-input]');

          if (input) {
            input.checked = false;
          }

          card.classList.remove('is-selected');

          const label =
            card.querySelector(
              '[data-addon-toggle-label]'
            );

          if (label) {
            label.textContent = '+ ADD';
          }
        }
      });
    };


    const getSelectedAddons = () => {
      const selected = [];

      addonCards.forEach((card) => {
        if (card.hidden) return;

        const input =
          card.querySelector('[data-addon-input]');

        if (!input || !input.checked) {
          return;
        }

        const qty =
          card.querySelector('[data-addon-qty]');

        const quantity =
          normalizeQuantity(qty?.value);


        selected.push({
          card,
          input,
          title:
            input.dataset.title ||
            input.value,

          sku:
            input.dataset.sku || '',

          variantId:
            input.dataset.variantId || '',

          price:
            getPriceCents(input),

          quantity
        });
      });

      return selected;
    };


    const updateSummary = () => {
      const base = getSelectedBase();

      if (!base) return;


      syncBaseCards();

      applyBaseRules();


      const addons =
        getSelectedAddons();

      const basePrice =
        getPriceCents(base);

      const quoteOnly =
        base.dataset.quoteOnly === 'true';

      let total =
        basePrice;


      addons.forEach((item) => {
        total +=
          item.price *
          item.quantity;
      });


      if (summaryBase) {
        summaryBase.textContent =
          base.dataset.title ||
          'Selected setup';
      }


      if (summaryBasePrice) {
        summaryBasePrice.textContent =
          money(basePrice);
      }


      if (summaryItems) {
        if (!addons.length) {
          summaryItems.innerHTML =
            '<p>No optional equipment selected.</p>';
        } else {
          summaryItems.innerHTML =
            addons
              .map((item) => `
                <div class="ozc-summary-item">
                  <span>
                    ${item.quantity} × ${item.title}
                  </span>

                  <strong>
                    ${money(
                      item.price *
                      item.quantity
                    )}
                  </strong>

                  <button
                    type="button"
                    class="ozc-summary-item__remove"
                    data-summary-remove="${item.variantId}"
                    aria-label="Remove optional item"
                  >
                    Remove
                  </button>
                </div>
              `)
              .join('');
        }
      }


      if (summaryTotal) {
        summaryTotal.textContent =
          money(total);
      }


      const configuration = [
        `Setup: ${base.dataset.title}` +
        `${base.dataset.sku ? ` [${base.dataset.sku}]` : ''}`,
        `Setup price: ${money(basePrice)}`,

        ...addons.map((item) =>
          `${item.quantity} x ${item.title}` +
          `${item.sku ? ` [${item.sku}]` : ''}` +
          ` — ${money(
            item.price * item.quantity
          )}`
        ),

        `Total: ${money(total)} incl GST`
      ].join(' | ');


      root.dispatchEvent(new CustomEvent(
        'oztech:configurator-change',
        {
          bubbles: true,
          detail: {
            amountCents: total,
            currency: 'AUD',
            productName:
              root.dataset.productName ||
              'P150 Max',
            selectedPackage:
              base.dataset.title || '',
            configuration
          }
        }
      ));


      let cartReady =
        Boolean(
          !quoteOnly &&
          base.dataset.variantId &&
          base.dataset.available === 'true'
        );


      addons.forEach((item) => {
        if (
          !item.variantId ||
          item.input.dataset.available !== 'true'
        ) {
          cartReady = false;
        }
      });


      if (addCartButton) {
        addCartButton.hidden = quoteOnly;

        addCartButton.disabled =
          !cartReady;
      }


      if (buyNowButton) {
        buyNowButton.hidden = quoteOnly;

        buyNowButton.disabled =
          !cartReady;
      }


      if (quoteOnlyButton) {
        quoteOnlyButton.hidden =
          !quoteOnly;
      }


      if (quoteButton) {
        quoteButton.hidden = quoteOnly;
      }


      if (secondaryActions) {
        const hasVisibleAction =
          Array.from(
            secondaryActions.querySelectorAll('a')
          ).some((link) => !link.hidden);

        secondaryActions.hidden =
          !hasVisibleAction;
      }


      if (cartNotice) {
        if (quoteOnly || cartReady) {
          cartNotice.hidden = true;
        } else {
          cartNotice.hidden = false;

          cartNotice.textContent =
            'Connect the selected setup to Shopify products to enable online purchase.';
        }
      }


      if (quoteButton || quoteOnlyButton) {
        const baseUrl =
          root.dataset.quoteUrl ||
          quoteButton?.getAttribute('href') ||
          quoteOnlyButton?.getAttribute('href') ||
          '/pages/contact';


        const separator =
          baseUrl.includes('?')
            ? '&'
            : '?';


        const quoteUrl =
          `${baseUrl}${separator}configuration=${encodeURIComponent(configuration)}`;


        if (quoteButton) {
          quoteButton.href = quoteUrl;
        }


        if (quoteOnlyButton) {
          quoteOnlyButton.href = quoteUrl;
        }
      }
    };


    summaryItems?.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-summary-remove]');

        if (!button) return;

        const item = getSelectedAddons().find(
          (addon) =>
            String(addon.variantId) ===
            String(button.dataset.summaryRemove)
        );

        if (!item) return;

        item.input.checked = false;
        item.card.classList.remove('is-selected');

        const label = item.card.querySelector(
          '[data-addon-toggle-label]'
        );

        if (label) {
          label.textContent = '+ ADD';
        }

        updateSummary();
      }
    );


    const getCartItems = () => {
      const base =
        getSelectedBase();

      if (
        !base ||
        base.dataset.quoteOnly === 'true'
      ) {
        return [];
      }


      const items = [];


      const baseVariantId =
        Number(
          base.dataset.variantId || 0
        );


      if (baseVariantId) {
        items.push({
          id: baseVariantId,
          quantity: 1
        });
      }


      getSelectedAddons()
        .forEach((item) => {
          const variantId =
            Number(item.variantId || 0);

          if (!variantId) return;

          items.push({
            id: variantId,
            quantity: item.quantity
          });
        });


      return items;
    };


    const sendToCart =
      async (goToCheckout) => {
        if (cartRequestPending) return;

        const base =
          getSelectedBase();

        if (
          !base ||
          base.dataset.quoteOnly === 'true'
        ) {
          return;
        }

        const items =
          getCartItems();

        if (!items.length) return;


        const button =
          goToCheckout
            ? buyNowButton
            : addCartButton;


        if (!button) return;

        cartRequestPending = true;

        const original =
          button.innerHTML;


        if (addCartButton) addCartButton.disabled = true;
        if (buyNowButton) buyNowButton.disabled = true;
        button.textContent = 'ADDING…';


        try {
          const response =
            await fetch(
              '/cart/add.js',
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json'
                },

                body:
                  JSON.stringify({
                    items
                  })
              }
            );


          if (!response.ok) {
            throw new Error(
              'Unable to add configuration.'
            );
          }


          window.location.href =
            goToCheckout
              ? '/checkout'
              : '/cart';


        } catch (error) {
          console.error(error);

          cartRequestPending = false;
          button.innerHTML = original;
          updateSummary();


          if (cartNotice) {
            cartNotice.hidden = false;

            cartNotice.textContent =
              'Unable to add this setup automatically. Please request a quote.';
          }
        }
      };


    root
      .querySelectorAll('[data-select-base]')
      .forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            const key =
              button.dataset.selectBase;

            const target =
              baseInputs.find(
                (input) =>
                  input.dataset.baseKey === key
              );


            if (!target) return;


            target.checked = true;

            target.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );
          }
        );
      });


    baseInputs.forEach((input) => {
      input.addEventListener(
        'change',
        updateSummary
      );
    });


    root
      .querySelectorAll('[data-base-card] .ozc-details')
      .forEach((details) => {
        details.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (event.target.closest('summary')) {
              details.open = !details.open;
            }
          }
        );
      });


    addonCards.forEach((card) => {
      const input =
        card.querySelector('[data-addon-input]');

      const toggle =
        card.querySelector('[data-addon-toggle]');

      const toggleLabel =
        card.querySelector(
          '[data-addon-toggle-label]'
        );

      const qty =
        card.querySelector('[data-addon-qty]');

      const minus =
        card.querySelector('[data-qty-minus]');

      const plus =
        card.querySelector('[data-qty-plus]');

      const variantSelect =
        card.querySelector('[data-addon-variant]');

      const livePrice =
        card.querySelector(
          '[data-addon-live-price]'
        );


      const syncAddon = () => {
        if (!input) return;

        card.classList.toggle(
          'is-selected',
          input.checked
        );

        if (toggleLabel) {
          toggleLabel.textContent =
            input.checked
              ? '✓ ADDED'
              : '+ ADD';
        }

        updateSummary();
      };


      toggle?.addEventListener(
        'click',
        () => {
          if (!input) return;

          input.checked =
            !input.checked;

          syncAddon();
        }
      );


      minus?.addEventListener(
        'click',
        () => {
          if (!qty) return;

          qty.value =
            Math.max(1, normalizeQuantity(qty.value) - 1);

          updateSummary();
        }
      );


      plus?.addEventListener(
        'click',
        () => {
          if (!qty) return;

          qty.value =
            normalizeQuantity(qty.value) + 1;

          updateSummary();
        }
      );


      qty?.addEventListener(
        'change',
        () => {
          qty.value = normalizeQuantity(qty.value);

          updateSummary();
        }
      );


      variantSelect?.addEventListener(
        'change',
        () => {
          if (!input) return;

          const option =
            variantSelect.options[
              variantSelect.selectedIndex
            ];


          input.dataset.variantId =
            option.value || '';

          input.dataset.priceCents =
            option.dataset.priceCents ||
            '0';

          input.dataset.priceText =
            option.dataset.priceText ||
            '';

          input.dataset.sku =
            option.dataset.sku ||
            '';

          input.dataset.available =
            option.disabled ? 'false' : 'true';


          if (livePrice) {
            livePrice.textContent =
              option.dataset.priceText ||
              money(
                option.dataset.priceCents
              );
          }


          updateSummary();
        }
      );
    });


    addCartButton?.addEventListener(
      'click',
      () => sendToCart(false)
    );


    buyNowButton?.addEventListener(
      'click',
      () => sendToCart(true)
    );


    if (
      !getSelectedBase() &&
      baseInputs.length
    ) {
      baseInputs[0].checked = true;
    }


    updateSummary();
  };


  const initAll = () => {
    document
      .querySelectorAll('[data-oz-configurator]')
      .forEach(initConfigurator);
  };


  window.OztechConfigurator = {
    initAll
  };


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }


  document.addEventListener(
    'shopify:section:load',
    initAll
  );
})();
